import 'moment/locale/ar';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AvailableBookingTimeSlot, GetBookingTimesQuery, Lawyer, TimeSlot } from '@/graphql/graphql';
import { useAppSelector } from '@/redux/hooks';
import { selectHomepage } from '@/redux/state/homepage';
import { selectLanguage } from '@/redux/state/language';
import { t } from 'i18next';
import moment, { Moment } from 'moment';
import React, { useState } from 'react';
import Datetime from 'react-datetime';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';

import GenericCard from './GenericCard';
import Listings from './Listing';


const pickService_t_prefix = "pages.homePage.pickService";

type ExcludedLawyerTypes = "ar" | "en" | "bookingTimeSlots"
type RemoveLawyerFields<Type> = {
  [Property in keyof Type as Exclude<Property, ExcludedLawyerTypes>]: Type[Property];
};

export type MappedAvailableTimesQuery<Type> = {
  [Property in keyof Type]: Type[Property] extends Lawyer ? RemoveLawyerFields<Type[Property]> : Type[Property]
}
interface BookingTImeProps {
  data: MappedAvailableTimesQuery<GetBookingTimesQuery>
}
const BookingTimeCard: React.FC<BookingTImeProps> = ({ data }) => {
  const { availableTimes } = data
  const { currentLanguage } = useAppSelector(selectLanguage);
  const [date, setDate] = useState<Moment | string>('');
  const valid = (current: Moment) => {
    const maxFutureDate = moment().add(1, "month");
    const yesterday = moment().subtract(1, "day");
    const inAvailableTimes = (dayOfYear: number) =>
      availableTimes!.filter(
        ({ timeSlot }) => moment(timeSlot.utcDate).dayOfYear() === dayOfYear
      ).length > 0;
    return (
      current.isAfter(yesterday) &&
      current.isBefore(maxFutureDate) &&
      inAvailableTimes(current.dayOfYear())
    );
  };
  const handleChange = (date: Moment | string) => setDate(date);

  const style: React.CSSProperties = {
    flex: "0 0 100%",
    maxWidth: "100%"
  }

  return (
    <Container className="date-picker mobile-test" style={style}>
      <Row xs="1" sm="1" md="1">
        <Col lg="4" xl="4">
          <Datetime
            onChange={handleChange}
            timeFormat={false}
            dateFormat="MM-DD"
            isValidDate={valid}
            locale={currentLanguage}
            input={false}
          />
        </Col>
        <Col lg="8" xl="8" style={{ padding: 0 }}>
          {date && <AvailableTimes date={date} data={data} />}
        </Col>
      </Row>
    </Container>
  );
};

interface AvailableTimesProps {
  date: string | Moment
  data: MappedAvailableTimesQuery<GetBookingTimesQuery>
}
const AvailableTimes: React.FC<AvailableTimesProps> = ({ date, data }) => {
  const { availableTimes } = data
  const { currentLanguage } = useAppSelector(selectLanguage)
  const { choices } = useAppSelector(selectHomepage);
  const { contactMethod } = choices;
  const dateMoment = moment(date)
  // Filter available times for chosen method type

  /**
   * Checks if the chosen contact method is available in the bookings times received from the server
   * @param {Object} contactType - the ContactType object sent from server
   * @param {String} contactType.id - the name of the contact method (one of [IN_PERSON, PHONE_CALL, ONLINE_MEETING])
   * @returns {boolean}
   */
  const isChosenContactType = (name: string) => name === contactMethod?.id;

  // Filter available times for chosen method type
  const ValidContactTypeTimes = availableTimes!.filter(({ contactType }) =>
    isChosenContactType(contactType.name)
  );

  /**
   * Checks if the given time slot is today and not in the past
   * @param {Object} timeSlot - the timeSlot object sent from server
   * @param {number} timeSlot.utcDate - UTC timestamp
   * @returns {boolean}
   */
  const isValidTime: (timeSlot: TimeSlot) => boolean = ({ utcDate }) => moment(utcDate).dayOfYear() === moment(date).dayOfYear();
  // && hour > new Date().getHours();

  const validTimes = ValidContactTypeTimes.filter(
    ({ timeSlot, booked }) => isValidTime(timeSlot) && !booked
  );

  console.log({ validTimes, ValidContactTypeTimes });

  return (
    <>
      <h5 style={{padding: "1rem", margin: 0}}>
        {t(`${pickService_t_prefix}.availableBookings`)} :{" "}
        {dateMoment.locale(currentLanguage).format("dddd, Do MMMM YYYY")}
      </h5>
      {ValidContactTypeTimes.length < 1 ? (
        <NoBookings />
      ) : validTimes.length < 1 ? (
        <FullyBooked />
      ) : (
        <Listings validTimes={validTimes} />
      )}
    </>
  );
};


const FullyBooked = () => {
  const { t } = useTranslation();
  return (
    <GenericCard>
      <h4
        style={{ margin: 0, textTransform: "capitalize" }}
        className="category-social"
      >
        <span>{t(`${pickService_t_prefix}.fullyBooked`)}</span>
      </h4>
    </GenericCard>
  );
};

export const NoBookings = () => {
  const { t } = useTranslation();
  return (
    <GenericCard>
      <h4
        style={{ margin: 0, textTransform: "capitalize" }}
        className="category-social"
      >
        <span>{t(`${pickService_t_prefix}.noAvailableBookings`)}</span>
      </h4>
    </GenericCard>
  );
};

export default BookingTimeCard;